import { gql, useMutation } from '@apollo/client';

const UNDO_CANCEL_SUBSCRIPTION = gql`
  mutation UndoCancelSubscription($subscriptionId: String!, $promoCodeId: String) {
    undoCancelSubscription(subscriptionId: $subscriptionId, promoCodeId: $promoCodeId)
  }
`;

export interface UndoCancelSubscriptionInput {
  subscriptionId: string;
  promoCodeId?: string;
}

export interface UndoCancelSubscriptionResult {
  undoCancelSubscription: boolean;
}

export function useSubscriptionUndoCancelMutation() {
  return useMutation<UndoCancelSubscriptionResult, UndoCancelSubscriptionInput>(UNDO_CANCEL_SUBSCRIPTION);
}
